export const GRAT_ANNUITIES_SUPPORTED_DECIMAL_PLACES = 10;
